<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <DispatchersTotals :from="from"
                       :to="to"
                       :key="from+to"
                       :dispatcherId="0"/>
    <v-layout v-if="!$root.isMobile">
      <!--<v-flex shrink class="pl-2">
        <v-switch dense v-model="showAllSwitch" @change="fetchData" inset label="Show all"/>
      </v-flex>-->
      <v-flex grow class="pt-3">
        <v-text-field dense outlined class="ml-2 mr-2"
                      prepend-inner-icon="mdi-magnify"
                      placeholder="Start typing to filter dispatcher by name"
                      v-model="search"/>
      </v-flex>
    </v-layout>
    <v-data-table
      v-if="!$root.isMobile"
      :headers="headers"
      :items="items"
      height="calc(100vh - 300px)"
      fixed-header
      dense
      :items-per-page="-1"
      hide-default-footer
      @click:row="onReportSubTypeChanged('/reports/dispatchers/' + $event.id)"
    >
      <template v-slot:top>
        <v-toolbar flat :style="{ backgroundColor: $root.currentTheme.background }">
          {{$t('Reports.DispatchersTotals')}}
        </v-toolbar>
      </template>
      <template v-slot:item.dispatcher="{ item }">
        {{item.dispatcher}}
      </template>
      <template v-slot:item.totalLoadsRate="{ item }">
        {{$root.moneyValue(item.totalLoadsRate, 0)}}
      </template>
      <template v-slot:item.totalAdditionalPayments="{ item }">
        {{$root.moneyValue(item.totalAdditionalPayments, 0)}}
      </template>
      <template v-slot:item.totalLoadsRateWithAdditionalPayments="{ item }">
        {{$root.moneyValue(item.totalLoadsRateWithAdditionalPayments, 0)}}
      </template>
      <template v-slot:item.totalDispatcherPaymentFromRate="{ item }">
        {{$root.moneyValue(item.totalDispatcherPaymentFromRate, 0)}}
      </template>
      <template v-slot:item.totalDispatcherPaymentFromBonus="{ item }">
        {{$root.moneyValue(item.totalDispatcherPaymentFromBonus, 0)}}
      </template>
      <template v-slot:item.totalDispatcherRate="{ item }">
        <v-chip small color="success">{{$root.moneyValue(item.totalDispatcherRate,0)}}</v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import DispatchersTotals from './DispatchersTotals.vue';
export default {
  name: 'DispatchersTotalsList',
  props: ['to', 'from'],
  mixins: [ reportsMixin ],
  components: {
    DispatchersTotals
  },
  data: function () {
    return {
      loading: false,
      items: [],
      totalsCounts: {},
      search: '',
      headers: [
        { text: 'Dispatcher', value: 'dispatcher' },
        { text: 'Loads', value: 'loadsCount' },
        { text: 'Loads Rate', value: 'totalLoadsRate' },
        { text: 'Additional Payments', value: 'totalAdditionalPayments' },
        { text: 'Total Loads Rate', value: 'totalLoadsRateWithAdditionalPayments' },
        { text: 'Salary From Loads Rate', value: 'totalDispatcherPaymentFromRate' },
        { text: 'Salary From Bonus', value: 'totalDispatcherPaymentFromBonus' },
        { text: 'Reports', value: 'savedReportsCount' },
        { text: 'Salary', value: 'totalDispatcherRate' },
        { text: '', value: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    filteredItems () {
      if (this.search.length === 0) {
        return Object.values(this.items);
      }
      return Object.values(this.items).filter((item) => {
        return item.dispatcher.toLowerCase().match(this.search);
      });
    }
  },
  mounted () {
    this.$store.dispatch('reports/totalsCountsNames', {
      loadsCount: 'Loads',
      totalLoadsRate: 'Initial Loads Rate',
      totalAdditionalPayments: 'Additional Payments',
      totalLoadsRateWithAdditionalPayments: 'Total Loads Rate',
      totalAvgLoadsRatePerMile: 'Avg. Rate Per Mile',
      totalDispatcherPaymentFromRate: 'Salary From Loads Rate',
      totalDispatcherPaymentFromBonus: 'Salary From Bonus',
      totalDispatcherRate: 'Salary'
    });
    this.fetchData();
  },
  methods: {
    onReportSubTypeChanged (path) {
      this.$root.setLocalStorageItem('reportTypePath', path);
      this.$root.route(path);
    },
    async fetchData () {
      let i = 0;
      let dispatchers = [];
      let dataResponse = {};
      let usersResponse = {};
      if (!this.from || !this.to) return;
      this.loading = true;
      // Get total miles
      this.items = [];
      usersResponse = await this.$root.loadUsersList(this.$store.getters.roleDispatcher, false, true);
      if (usersResponse.status === 'ok') {
        dispatchers = usersResponse.result.data;
      }
      // Calc totals only for a big screen
      if (!this.$root.isMobile) {
        for (i = 0; i < dispatchers.length; i++) {
          dataResponse = await this.getDispatchersReportTotalData(this.from, this.to, dispatchers[i].id);
          if (dataResponse.status === 'ok') {
            this.items.push(dataResponse.results);
            this.items[this.items.length - 1].id = dispatchers[i].id;
            this.items[this.items.length - 1].dispatcher = dispatchers[i].firstName + ' ' + dispatchers[i].lastName;
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>
